<template lang="pug">
  .wrap
    .main
      h2 事業所リスト管理
        span.data-count データ数：{{ pagination.totalCount }}件
      .company-list
        CompanyColumnSortModal
        .company-list-body
          table.row-list
            CompanyTableHeader(
              :checked="pageAllChecked",
              @check="togglePageCheck",
              :leadManagementShareButton="user.lead_management"
            )
            CompanyTableRow(
              v-for="(v, i) in index",
              :company="v",
              :index="i",
              :key="v.id",
              :updateMarkForIndex="true",
              :checkedIds="pageCheckedIds",
              @check="toggleCheck",
              @update="reloadOrSkip",
              :leadManagementShareButton="user.lead_management"
            )
          CompanyListMenu(
            @remove="reload"
            :checkedIds="pageCheckedIds"
            :leadManagementShareButton="user.lead_management"
          )
        Pagination(
          :pagination="pagination"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage")
    AddAccountModal(:update="updateIndex")
    Footer
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import { ErrorMessages } from '../constants'
  import CompanyColumnSortModal from './parts/CompanyColumnSortModal'
  import CompanyMenu from './parts/CompanyMenu'
  import CompanySortArea from './parts/CompanySortArea'
  import CompanyTableHeader from './parts/CompanyTableHeader'
  import CompanyTableRow from './parts/CompanyTableRow'
  import CompanyListMenu from './parts/CompanyListMenu'
  import Footer from './parts/Footer'
  import Pagination from './parts/Pagination'
  import AddAccountModal from './parts/AddAccountModal'

  export default {
    components: {
      CompanyColumnSortModal,
      CompanyMenu,
      CompanySortArea,
      CompanyTableHeader,
      CompanyTableRow,
      CompanyListMenu,
      Footer,
      Pagination,
      AddAccountModal,
    },
    async asyncData ({ store, route: { query: { perPage, page } } }) {
      if (!perPage || !page) {
        throw new Error(ErrorMessages.NO_PAGE_PARAMETER)
      }
      await store.dispatch('jobMark/fetchIndex', { perPage, page })
    },
    data () {
      return {
        headerFixedSp: false,
        openSidebar: false,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    computed: {
      ...mapGetters('jobMark', ['pageAllChecked']),
      ...mapGetters('common', ['spMode']),
      ...mapState({
        meta: state => state.route.meta,
        pagination: state => state.jobMark.pagination,
        index: state => state.jobMark.index,
        pageCheckedIds: state => state.jobMark.pageCheckedIds,
        user: state => state.user.detail,
        page () {
          return this.$route.query.page
        },
        perPage () {
          return this.$route.query.perPage
        },
      }),
    },
    methods: {
      ...mapActions('jobMark', ['toggleCheck', 'togglePageCheck']),
      async searchOrderBy (target) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            order: target,
            page: '1',
            _t: Date.now(),
          },
        })
      },
      handleScroll () {
        if (this.spMode) {
          this.headerFixedSp = (window.scrollY > 60)
        } else {
          this.headerFixedSp = false
        }
      },
      reload ({ perPage, page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            perPage: perPage || query.perPage,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrSkip () {
        if (this.spMode) {
          return
        }
        this.reload()
      },
      skipReload () {},
      async selectPage (page) {
        this.reload({ page })
      },
      async selectPerPage (perPage) {
        this.updateCompaniesPerPage(perPage)
        this.reload({ perPage, page: '1' })
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
      async updateCompaniesPerPage (companiesPerPage) {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('user/updateCompaniesPerPage', { companiesPerPage })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      avoidBlank () {
        const { query } = this.$route
        const page = parseInt(query.page, 10) || 1

        // 直近の fetchIndex がエラーで終わった場合は page-- しない。
        // 取得失敗で空配列になった画面で page-- を続けるとエラーループになる。
        // CompanyList は jobMark store の index を表示しているのでそちらを参照する。
        if (this.$store.state.jobMark.lastFetchError) return

        // 連射防止: API エラー時に暴走して連続リクエストを飛ばすのを防ぐ
        // eslint-disable-next-line no-underscore-dangle
        if (this._avoidBlankGuard) return

        if (!this.index.length && page > 1) {
          // eslint-disable-next-line no-underscore-dangle
          this._avoidBlankGuard = true
          // eslint-disable-next-line no-underscore-dangle
          setTimeout(() => { this._avoidBlankGuard = false }, 3000)
          this.$router.push({ query: { ...query, page: page - 1 } })
        }
      },
      updateIndex (ids) {
        this.$store.commit('jobMark/updateIndexForAccount', ids)
        this.$store.commit('jobMark/uncheckAll')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/CompanyList.vue